/** Table lookup that falls back for a key the table doesn't own (an enum value the backend added later). */
export function lookupOr<V>(table: Readonly<Record<string, V>>, key: string, fallback: NoInfer<V>): V {
  return Object.prototype.hasOwnProperty.call(table, key) ? (table[key] as V) : fallback;
}
